/* AurexOne clean storefront v5.0 — By Ali Hassan */
/* ApexLink Peptides storefront revamp — By Ali Hassan */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function initAnnouncementBar() {
    var bar = document.getElementById("jsAnnBar2024");
    if (!bar) return;

    var slides = bar.querySelectorAll(".js-ann-bar-2024__slide");
    var prevBtn = bar.querySelector(".js-ann-bar-2024__arrow--prev");
    var nextBtn = bar.querySelector(".js-ann-bar-2024__arrow--next");
    if (!slides.length) return;

    var index = 0;
    var timer = null;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i += 1) {
        var active = i === index;
        slides[i].classList.toggle("is-active", active);
        slides[i].setAttribute("aria-hidden", active ? "false" : "true");
      }
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!reduceMotion && slides.length > 1 && !document.hidden) {
        timer = window.setInterval(function () { show(index + 1); }, 4200);
      }
    }

    if (nextBtn) nextBtn.addEventListener("click", function () { show(index + 1); start(); });
    if (prevBtn) prevBtn.addEventListener("click", function () { show(index - 1); start(); });
    bar.addEventListener("mouseenter", stop);
    bar.addEventListener("mouseleave", start);
    document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });

    show(0);
    start();
  }

  function initMobileNavigation() {
    var nav = document.querySelector(".apx-mobile-nav");
    if (!nav) return;

    function closeNav() {
      nav.removeAttribute("open");
      document.documentElement.classList.remove("apx-mobile-nav-open");
    }
    nav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeNav);
    });
    var closeButton = nav.querySelector("[data-apx-mobile-nav-close]");
    if (closeButton) closeButton.addEventListener("click", closeNav);
    nav.addEventListener("toggle", function () {
      document.documentElement.classList.toggle("apx-mobile-nav-open", nav.hasAttribute("open"));
    });
    nav.addEventListener("click", function (event) {
      if (event.target === nav && nav.hasAttribute("open")) closeNav();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && nav.hasAttribute("open")) closeNav();
    });
  }

  function initProductPage() {
    var product = document.querySelector("[data-apx-product]");
    if (!product) return;

    var mainImage = product.querySelector(".apx-pdp__main-image");
    var thumbs = product.querySelectorAll("[data-apx-thumb]");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (mainImage && thumb.dataset.imageSrc) {
          /* Shopify image_tag outputs srcset. If only src changes, the browser can keep
             displaying the old srcset candidate. Remove it before swapping the image. */
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.src = thumb.dataset.imageSrc;
          if (thumb.dataset.imageAlt) mainImage.alt = thumb.dataset.imageAlt;
        }
        thumbs.forEach(function (item) { item.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });

    var qty = product.querySelector("[data-apx-qty]");
    if (qty) {
      var input = qty.querySelector("input");
      var minus = qty.querySelector("[data-apx-qty-minus]");
      var plus = qty.querySelector("[data-apx-qty-plus]");
      if (minus) minus.addEventListener("click", function () {
        var value = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = Math.max(1, value - 1);
      });
      if (plus) plus.addEventListener("click", function () {
        var value = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = value + 1;
      });
      if (input) {
        input.addEventListener("input", function () {
          var clean = input.value.replace(/[^0-9]/g, "");
          input.value = clean === "" ? "" : String(Math.max(1, parseInt(clean, 10) || 1));
        });
        input.addEventListener("blur", function () {
          input.value = String(Math.max(1, parseInt(input.value, 10) || 1));
        });
      }
    }

    initPdpDetailSpy(product);

    var variantSelect = product.querySelector("[data-apx-variant-select]");
    if (variantSelect) {
      variantSelect.addEventListener("change", function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        var price = product.querySelector("[data-apx-price]");
        var compare = product.querySelector("[data-apx-compare]");
        var sku = product.querySelector(".engoj-variant-sku");

        if (price && option.dataset.price) price.innerHTML = option.dataset.price;
        if (compare) {
          var compareRaw = parseInt(option.dataset.compareRaw || "0", 10);
          var priceRaw = parseInt(option.dataset.priceRaw || "0", 10);
          if (compareRaw > priceRaw) {
            compare.innerHTML = option.dataset.compare || "";
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }
        if (sku) sku.textContent = option.dataset.sku || "APX";
        if (mainImage && option.dataset.image) {
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.src = option.dataset.image;
        }

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", option.value);
          window.history.replaceState({}, "", url.toString());
        }
      });
    }
  }



  function initPdpDetailSpy(product) {
    var nav = product.querySelector(".apx-pdp-details__nav");
    if (!nav) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll("[data-apx-detail-link]"));
    var sections = Array.prototype.slice.call(product.querySelectorAll("[data-apx-detail-section]"));
    if (!links.length || !sections.length) return;

    function activate(id) {
      links.forEach(function (link) {
        var active = link.getAttribute("href") === "#" + id;
        link.classList.toggle("is-active", active);
        if (active) {
          link.setAttribute("aria-current", "true");
          if (window.innerWidth <= 991 && nav.scrollWidth > nav.clientWidth) {
            var targetLeft = link.offsetLeft - (nav.clientWidth / 2) + (link.offsetWidth / 2);
            if (nav.scrollTo) nav.scrollTo({ left: Math.max(0, targetLeft), behavior: "smooth" });
            else nav.scrollLeft = Math.max(0, targetLeft);
          }
        } else {
          link.removeAttribute("aria-current");
        }
      });
    }

    links.forEach(function (link) {
      link.addEventListener("click", function () {
        var id = (link.getAttribute("href") || "").replace("#", "");
        if (id) activate(id);
      });
    });

    activate(sections[0].id);

    if ("IntersectionObserver" in window) {
      var visible = {};
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible[entry.target.id] = entry.isIntersecting ? entry.intersectionRatio : 0;
        });
        var best = sections[0].id;
        var bestRatio = -1;
        sections.forEach(function (section) {
          var ratio = visible[section.id] || 0;
          if (ratio > bestRatio) { bestRatio = ratio; best = section.id; }
        });
        if (bestRatio > 0) activate(best);
      }, { rootMargin: "-22% 0px -58% 0px", threshold: [0, 0.1, 0.25, 0.5, 0.75] });
      sections.forEach(function (section) { observer.observe(section); });
      return;
    }

    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var marker = window.innerHeight * 0.34;
        var current = sections[0];
        sections.forEach(function (section) {
          if (section.getBoundingClientRect().top <= marker) current = section;
        });
        activate(current.id);
        ticking = false;
      });
    }, { passive: true });
  }


  function initEditorialPages() {
    var page = document.querySelector("[data-apx-editorial-page]");
    if (!page) return;

    var content = page.querySelector("[data-apx-page-content]");
    var tocWrap = page.querySelector("[data-apx-page-toc-wrap]");
    var toc = page.querySelector("[data-apx-page-toc]");
    if (!content || !toc) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll("h2"));
    if (!headings.length) {
      if (tocWrap) tocWrap.hidden = true;
      return;
    }

    function slugify(value) {
      return (value || "section")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-") || "section";
    }

    var used = {};
    var links = [];
    headings.forEach(function (heading, index) {
      var base = heading.id || slugify(heading.textContent);
      var id = base;
      var count = 2;
      while (used[id] || (document.getElementById(id) && document.getElementById(id) !== heading)) { id = base + "-" + count; count += 1; }
      used[id] = true;
      heading.id = id;

      var link = document.createElement("a");
      link.href = "#" + id;
      link.textContent = heading.textContent.trim() || ("Section " + (index + 1));
      link.dataset.apxPageTocLink = id;
      toc.appendChild(link);
      links.push(link);
    });

    function activate(id) {
      links.forEach(function (link) {
        var active = link.dataset.apxPageTocLink === id;
        link.classList.toggle("is-active", active);
        if (active) {
          link.setAttribute("aria-current", "true");
          if (window.innerWidth <= 991 && toc.scrollWidth > toc.clientWidth) {
            var targetLeft = link.offsetLeft - (toc.clientWidth / 2) + (link.offsetWidth / 2);
            if (toc.scrollTo) toc.scrollTo({ left: Math.max(0, targetLeft), behavior: "smooth" });
          }
        } else {
          link.removeAttribute("aria-current");
        }
      });
    }

    links.forEach(function (link) {
      link.addEventListener("click", function () { activate(link.dataset.apxPageTocLink); });
    });
    activate(headings[0].id);

    if ("IntersectionObserver" in window) {
      var visible = {};
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { visible[entry.target.id] = entry.isIntersecting ? entry.intersectionRatio : 0; });
        var best = headings[0].id;
        var bestRatio = -1;
        headings.forEach(function (heading) {
          var ratio = visible[heading.id] || 0;
          if (ratio > bestRatio) { bestRatio = ratio; best = heading.id; }
        });
        if (bestRatio > 0) activate(best);
      }, { rootMargin: "-20% 0px -64% 0px", threshold: [0, 0.1, 0.25, 0.5, 0.75] });
      headings.forEach(function (heading) { observer.observe(heading); });
    }
  }


  function initPdpReviews() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll("[data-apx-write-review]"));
    if (!buttons.length) return;

    var fallback = document.querySelector("[data-apx-review-form]");
    var close = fallback ? fallback.querySelector("[data-apx-review-close]") : null;

    function openReview(event) {
      if (event) event.preventDefault();

      /* Prefer a connected review app's native write-review action when present. */
      var nativeTrigger = document.querySelector(
        ".spr-summary-actions-newreview, .jdgm-write-rev-link, .loox-write-review-button, [data-write-review]:not([data-apx-write-review])"
      );
      if (nativeTrigger && !nativeTrigger.closest("[data-apx-review-form]")) {
        nativeTrigger.click();
        var reviews = document.getElementById("apx-reviews");
        if (reviews) reviews.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      if (!fallback) return;
      fallback.hidden = false;
      fallback.scrollIntoView({ behavior: "smooth", block: "center" });
      window.setTimeout(function () {
        var first = fallback.querySelector("input:not([type='hidden']), textarea");
        if (first) first.focus({ preventScroll: true });
      }, 350);
    }

    buttons.forEach(function (button) { button.addEventListener("click", openReview); });
    if (close) close.addEventListener("click", function () { fallback.hidden = true; });

    /* Keep the fallback visible after Shopify returns validation or success state. */
    if (fallback && (fallback.querySelector(".errors") || fallback.querySelector(".apx-review-form__success"))) {
      fallback.hidden = false;
    }
  }

  function initCertificateSearch() {
    var input = document.querySelector("[data-apx-cert-search]");
    if (!input) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll("[data-apx-cert-card]"));
    var seenCertificateKeys = {};
    cards.forEach(function (card) {
      var key = card.getAttribute("data-cert-key");
      if (!key) return;
      if (seenCertificateKeys[key]) card.setAttribute("data-apx-cert-duplicate", "true");
      else seenCertificateKeys[key] = true;
    });
    cards = cards.filter(function (card) {
      if (card.getAttribute("data-apx-cert-duplicate") === "true") { card.hidden = true; return false; }
      return true;
    });
    var count = document.querySelector("[data-apx-cert-count]");
    var empty = document.querySelector("[data-apx-cert-empty]");
    if (count) count.textContent = cards.length;
    input.addEventListener("input", function () {
      var term = input.value.trim().toLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var match = !term || (card.dataset.title || "").indexOf(term) !== -1;
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (count) count.textContent = visible;
      if (empty) empty.hidden = visible !== 0;
    });
  }

  function initFilterDrawer() {
    var drawer = document.querySelector(".apx-filter-drawer");
    if (!drawer) return;
    var closeButtons = drawer.querySelectorAll("[data-apx-filter-close]");
    var mq = window.matchMedia("(max-width: 991px)");

    function sync() {
      var mobileOpen = drawer.hasAttribute("open") && mq.matches;
      document.documentElement.classList.toggle("apx-filter-open", mobileOpen);
      if (!mobileOpen) document.documentElement.classList.remove("apx-filter-open");
    }
    function close() {
      drawer.removeAttribute("open");
      sync();
    }

    drawer.addEventListener("toggle", sync);
    closeButtons.forEach(function (button) { button.addEventListener("click", close); });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && drawer.hasAttribute("open")) close();
    });
    document.addEventListener("click", function (event) {
      if (!drawer.hasAttribute("open") || mq.matches) return;
      if (!drawer.contains(event.target)) close();
    });
    if (mq.addEventListener) mq.addEventListener("change", sync);
    else if (mq.addListener) mq.addListener(sync);
    sync();
  }


  function initLiveProductSearch() {
    var box = document.querySelector('.js-box-search');
    if (!box || !window.fetch) return;

    var input = box.querySelector('.js_engo_autocomplate');
    var resultsWrap = box.querySelector('.js_productSearchResults');
    var results = resultsWrap ? resultsWrap.querySelector('.js_search_results') : null;
    var form = input ? input.closest('form') : null;
    if (!input || !resultsWrap || !results) return;

    var debounceTimer = 0;
    var controller = null;
    var requestId = 0;

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function clearResults() {
      results.innerHTML = '';
      resultsWrap.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function showMessage(message) {
      results.innerHTML = '<div class="apx-live-search-message">' + escapeHtml(message) + '</div>';
      resultsWrap.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function renderProducts(products, query) {
      if (!products.length) {
        showMessage('No matching products found.');
        return;
      }

      var html = '<div class="apx-live-search-list" role="list">';
      products.forEach(function (product) {
        var href = product.url || (product.handle ? '/products/' + product.handle : '#');
        var image = product.featured_image && product.featured_image.url ? product.featured_image.url : '';
        var imageAlt = product.featured_image && product.featured_image.alt ? product.featured_image.alt : product.title;
        var productType = product.type || 'Research material';

        html += '<a class="apx-live-search-item" href="' + escapeHtml(href) + '" role="listitem">';
        html += '<span class="apx-live-search-item__media">';
        if (image) {
          html += '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy">';
        }
        html += '</span>';
        html += '<span class="apx-live-search-item__content">';
        html += '<small>' + escapeHtml(productType) + '</small>';
        html += '<strong>' + escapeHtml(product.title) + '</strong>';
        html += '</span>';
        html += '<span class="apx-live-search-item__action">View <span aria-hidden="true">→</span></span>';
        html += '</a>';
      });
      html += '</div>';
      html += '<a class="apx-live-search-all" href="/search?type=product&q=' + encodeURIComponent(query) + '">View all search results <span aria-hidden="true">→</span></a>';

      results.innerHTML = html;
      resultsWrap.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function requestSuggestions(query) {
      requestId += 1;
      var currentRequest = requestId;

      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;

      var endpoint = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
      var options = { headers: { 'Accept': 'application/json' } };
      if (controller) options.signal = controller.signal;

      fetch(endpoint, options)
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.json();
        })
        .then(function (data) {
          if (currentRequest !== requestId || input.value.trim() !== query) return;
          var products = data && data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products
            : [];
          renderProducts(products, query);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (currentRequest !== requestId) return;
          showMessage('Suggestions are unavailable. Press Enter to search.');
        });
    }

    function handleInput() {
      var query = input.value.trim();
      window.clearTimeout(debounceTimer);

      if (!query) {
        if (controller) controller.abort();
        clearResults();
        return;
      }

      debounceTimer = window.setTimeout(function () {
        requestSuggestions(query);
      }, 140);
    }

    input.setAttribute('aria-expanded', 'false');
    input.addEventListener('input', handleInput);
    input.addEventListener('focus', function () {
      if (input.value.trim() && results.innerHTML.trim()) {
        resultsWrap.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });
    if (form) {
      form.addEventListener('submit', function () {
        window.clearTimeout(debounceTimer);
        if (controller) controller.abort();
      });
    }
    clearResults();
  }

  function initHeaderActions() {
    function openSearch(event) {
      if (event) event.preventDefault();
      var box = document.querySelector('.js-box-search');
      var bg = document.querySelector('.bg_search_box');
      if (!box) {
        window.location.href = '/search';
        return;
      }
      box.classList.add('active');
      if (bg) bg.classList.add('active');
      document.body.classList.add('activedestop');
      window.setTimeout(function () {
        var input = box.querySelector('input[name="q"]');
        if (input) input.focus();
      }, 120);
    }

    function closeSearch(event) {
      if (event) event.preventDefault();
      var box = document.querySelector('.js-box-search');
      var bg = document.querySelector('.bg_search_box');
      if (box) box.classList.remove('active');
      if (bg) bg.classList.remove('active');
      document.body.classList.remove('activedestop');
    }

    function openCart(event) {
      if (event) event.preventDefault();
      var cart = document.querySelector('.js-minicart');
      var bg = document.querySelector('.bg-minicart');
      if (!cart) {
        window.location.href = '/cart';
        return;
      }
      cart.classList.add('active');
      if (bg) bg.classList.add('active');
    }

    function closeCart(event) {
      if (event) event.preventDefault();
      var cart = document.querySelector('.js-minicart');
      var bg = document.querySelector('.bg-minicart');
      if (cart) cart.classList.remove('active');
      if (bg) bg.classList.remove('active');
    }

    document.addEventListener('click', function (event) {
      var searchTrigger = event.target.closest('.js-search-destop');
      if (searchTrigger) { openSearch(event); return; }
      var cartTrigger = event.target.closest('.js-call-minicart');
      if (cartTrigger) { openCart(event); return; }
      if (event.target.closest('.js-drawer-close') || event.target.closest('.bg_search_box')) { closeSearch(event); return; }
      if (event.target.closest('.close-mini-cart') || event.target.closest('.bg-minicart')) { closeCart(event); }
    });
  }

  function initStatsCarousel() {
    var carousels = document.querySelectorAll('[data-apx-stats-carousel]');
    carousels.forEach(function (carousel) {
      var viewport = carousel.querySelector('.apx2-stats__viewport');
      var track = carousel.querySelector('[data-apx-stats-track]');
      var prev = carousel.querySelector('[data-apx-stats-prev]');
      var next = carousel.querySelector('[data-apx-stats-next]');
      if (!viewport || !track || carousel.dataset.apxStatsReady === 'true') return;
      carousel.dataset.apxStatsReady = 'true';

      var originalItems = Array.prototype.slice.call(track.querySelectorAll('.apx2-stat'));
      if (!originalItems.length) return;

      /* One duplicated cycle gives us a seamless visual hand-off. */
      originalItems.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        track.appendChild(clone);
      });

      var cycleWidth = 0;
      var rafId = 0;
      var lastFrame = 0;
      var resumeTimer = 0;
      var pausedUntil = 0;
      var SPEED = 80; /* pixels per second: calm, continuous movement */

      function getGap() {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || '0') || 0;
      }

      function stepWidth() {
        var item = originalItems[0];
        return item ? item.getBoundingClientRect().width + getGap() : viewport.clientWidth * 0.8;
      }

      function measureCycle() {
        var firstClone = track.children[originalItems.length];
        cycleWidth = firstClone ? firstClone.offsetLeft - originalItems[0].offsetLeft : stepWidth() * originalItems.length;
      }

      function normalizePosition() {
        if (!cycleWidth) measureCycle();
        if (!cycleWidth) return;
        while (viewport.scrollLeft >= cycleWidth) viewport.scrollLeft -= cycleWidth;
        while (viewport.scrollLeft < 0) viewport.scrollLeft += cycleWidth;
      }

      function pauseFor(ms) {
        pausedUntil = Date.now() + ms;
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(function () {
          lastFrame = performance.now();
          normalizePosition();
        }, ms + 20);
      }

      function move(direction) {
        if (!cycleWidth) measureCycle();
        if (direction < 0 && viewport.scrollLeft < stepWidth() * 0.55 && cycleWidth) {
          viewport.scrollLeft += cycleWidth;
        }
        pauseFor(720);
        viewport.scrollBy({ left: direction * stepWidth(), behavior: 'smooth' });
        window.setTimeout(normalizePosition, 680);
      }

      function animate(now) {
  if (!lastFrame) {
    lastFrame = now;
  }

  var delta = now - lastFrame;
  lastFrame = now;

  // Prevent large jumps after browser tab becomes active again
  if (delta > 40) {
    delta = 16.67;
  }

  if (
    !document.hidden &&
    Date.now() >= pausedUntil &&
    cycleWidth > 0
  ) {
    viewport.scrollLeft += SPEED * (delta / 1000);

    if (viewport.scrollLeft >= cycleWidth) {
      viewport.scrollLeft -= cycleWidth;
    }
  }

  rafId = window.requestAnimationFrame(animate);
}

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });

      /* Let visitors swipe/drag naturally, then resume continuous autoplay. */
      viewport.addEventListener('pointerdown', function () { pauseFor(1100); }, { passive: true });
      viewport.addEventListener('touchstart', function () { pauseFor(1100); }, { passive: true });
      viewport.addEventListener('wheel', function () { pauseFor(900); }, { passive: true });

      function syncArrows() {
        measureCycle();
        normalizePosition();
        var hasOverflow = originalItems.length > 1 && cycleWidth > viewport.clientWidth + 4;
        if (prev) prev.hidden = !hasOverflow;
        if (next) next.hidden = !hasOverflow;
      }

      viewport.scrollLeft = 0;
      syncArrows();
      rafId = window.requestAnimationFrame(animate);

      window.addEventListener('resize', function () {
        pauseFor(160);
        syncArrows();
      });

      document.addEventListener('visibilitychange', function () {
        lastFrame = performance.now();
      });
    });
  }

  function initCartQuantity() {
    var form = document.querySelector('[data-apx-cart-form]');
    if (!form) return;
    var updateButton = form.querySelector('[data-apx-cart-update]');
    var submitTimer = null;

    function scheduleUpdate() {
      window.clearTimeout(submitTimer);
      submitTimer = window.setTimeout(function () {
        if (form.requestSubmit && updateButton) form.requestSubmit(updateButton);
        else form.submit();
      }, 250);
    }

    form.querySelectorAll('[data-apx-cart-qty]').forEach(function (control) {
      var input = control.querySelector('[data-apx-cart-qty-input]');
      var minus = control.querySelector('[data-apx-cart-qty-minus]');
      var plus = control.querySelector('[data-apx-cart-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        scheduleUpdate();
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + 1);
        scheduleUpdate();
      });
      input.addEventListener('change', function () {
        input.value = Math.max(1, parseInt(input.value, 10) || 1);
        scheduleUpdate();
      });
      input.addEventListener('input', function () {
        input.value = input.value.replace(/[^0-9]/g, '');
      });
    });
  }

  function initPriceSteppers() {
    document.querySelectorAll('[data-apx-price-filter]').forEach(function (filter) {
      filter.addEventListener('click', function (event) {
        var button = event.target.closest('[data-apx-price-step]');
        if (!button) return;
        event.preventDefault();
        var stepper = button.closest('.apx-price-stepper');
        var input = stepper ? stepper.querySelector('input[type="number"]') : null;
        if (!input) return;
        var direction = parseFloat(button.getAttribute('data-apx-price-step')) || 0;
        var step = parseFloat(input.step) || 1;
        var min = input.min !== '' ? parseFloat(input.min) : 0;
        var max = input.max !== '' ? parseFloat(input.max) : Number.POSITIVE_INFINITY;
        var minInput = filter.querySelector('[data-apx-price-input="min"]');
        var maxInput = filter.querySelector('[data-apx-price-input="max"]');
        if (input.dataset.apxPriceInput === 'min' && maxInput && maxInput.value !== '') {
          max = Math.min(max, parseFloat(maxInput.value));
        }
        if (input.dataset.apxPriceInput === 'max' && minInput && minInput.value !== '') {
          min = Math.max(min, parseFloat(minInput.value));
        }
        var fallback = input.dataset.apxPriceInput === 'max' ? max : min;
        var value = input.value === '' ? fallback : parseFloat(input.value);
        if (!Number.isFinite(value)) value = fallback;
        value = Math.min(max, Math.max(min, value + (direction * step)));
        input.value = String(Math.round(value * 100) / 100);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }


  function initShippingSliders() {
    function mount(slider) {
      if (!slider || slider.dataset.apxShippingReady === 'true') return;
      slider.dataset.apxShippingReady = 'true';

      var slides = slider.querySelectorAll('[data-apx-shipping-slide]');
      var prev = slider.querySelector('[data-apx-shipping-prev]');
      var next = slider.querySelector('[data-apx-shipping-next]');
      if (!slides.length) return;

      var index = 0;
      var timer = null;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      }

      function restart() {
        if (timer) window.clearInterval(timer);
        if (!reduced && slides.length > 1) {
          timer = window.setInterval(function () { show(index + 1); }, 3600);
        }
      }

      if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(index + 1); restart(); });
      show(0);
      restart();
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-apx-shipping-slider]').forEach(mount);
    }

    scan(document);

    if ('MutationObserver' in window && document.body) {
      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && node.matches('[data-apx-shipping-slider]')) mount(node);
            if (node.querySelectorAll) scan(node);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function normalizeSupportEmail() {
    var support = 'support@apexlinkpeptides.com';
    var areas = document.querySelectorAll('.apx-editorial-rte, .apx-contact, .shopify-policy__body, .shopify-policy__container');
    var emailPattern = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
    areas.forEach(function (area) {
      area.querySelectorAll('a[href^="mailto:"]').forEach(function (link) {
        link.setAttribute('href', 'mailto:' + support);
        if (emailPattern.test(link.textContent || '')) link.textContent = support;
        emailPattern.lastIndex = 0;
      });
      var walker = document.createTreeWalker(area, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        if (!node.parentElement || node.parentElement.closest('script,style,input,textarea')) return;
        var value = node.nodeValue || '';
        if (emailPattern.test(value)) node.nodeValue = value.replace(emailPattern, support);
        emailPattern.lastIndex = 0;
        if (/Email\s*:\s*apexlinkpeptides\.com/i.test(node.nodeValue || '')) {
          node.nodeValue = node.nodeValue.replace(/Email\s*:\s*apexlinkpeptides\.com/gi, 'Email: ' + support);
        }
      });
    });
  }

  ready(function () {
    initAnnouncementBar();
    initShippingSliders();
    initHeaderActions();
    initLiveProductSearch();
    initMobileNavigation();
    initStatsCarousel();
    initProductPage();
    initPdpReviews();
    initFilterDrawer();
    initPriceSteppers();
    initCartQuantity();
    initCertificateSearch();
    normalizeSupportEmail();
    initEditorialPages();
  });
})();
